import * as R from 'ramda';
import { mapProps, withState, lifecycle } from 'recompose';
import { Form } from 'antd';
import { connect } from 'react-redux';
import message from 'antd/lib/message';

import InviteUserFormComp from './invite-user-form-comp';
import { inviteUser } from '../../../redux/thunk/invitations';
import {
  inviteUserFailure,
  inviteUserFetched,
  inviteUserSuccess,
} from '../../../redux/actions/invitations';
import { getResErrorMsg } from '../../../utils/axios';

import { USER_ROLES } from '../../../api/constants';

const mapStateToProps = ({
  invitationsUser,
}) => ({
  invitationsUser,
});

export const InviteUserForm = Form.create()(R.compose(
  connect(
    mapStateToProps,
    {
      inviteUser, inviteUserFetched, inviteUserFailure, inviteUserSuccess,
    },
  ),
  withState('invitationLink', 'setInvitationLink', ''),
  mapProps(({
    form,
    users,
    isFetching,
    invitationsUser,
    setInvitationLink,
    invitationLink,
    authorizedUser,
    ...actions
  }) => ({
    form,
    isFetching,
    invitationsUser,
    invitationLink,
    authorizedUser,
    onInviteUser: (event) => {
      event.preventDefault();
      form.validateFieldsAndScroll((err, value) => {
        if (!err) {
          Promise.resolve(actions.inviteUser(value))
            .then(() => {
              actions.inviteUserSuccess();
              form.resetFields();
              form.setFieldsValue({
                role: USER_ROLES.USER,
              });
              message.success('Invitation successfully sent to user via email');
            })
            .catch((error) => {
              message.error(getResErrorMsg(error));
              actions.inviteUserFailure();
            });
        } else {
          console.log(err);
        }
      });
    },
  })),
  lifecycle({
    componentDidMount() {
      this.props.form.setFieldsValue({
        role: USER_ROLES.USER,
      });
    },
  }),
)(InviteUserFormComp));



// WEBPACK FOOTER //
// ./src/modals/manage-users-modal/invite-user-form/invite-user-form.js